import React, {
    cloneElement,
    isValidElement,
    ReactNode,
    useMemo,
    useId,
    useState,
    useCallback,
} from 'react';
import { CopyIcon } from '../../assets/icons';
import { Tooltip } from 'react-tooltip';
import 'react-tooltip/dist/react-tooltip.css';
import Portal from '../Portal';
import clsx from 'clsx';

type InfoPopUpProp = {
    copyText: string;
    children: ReactNode;
    trigger?: ReactNode;
    className?: string;
};

const CopyPopUp: React.FC<InfoPopUpProp> = ({
    className = '',
    children,
    trigger,
    copyText,
}) => {
    const uuid = useId();

    const [isOpen, setIsOpen] = useState(false);

    const handleOpen = useCallback(
        (e: React.MouseEvent) => {
            e.stopPropagation();

            navigator.clipboard.writeText(copyText);

            setIsOpen(true);

            setTimeout(() => {
                setIsOpen(false);
            }, 1500);
        },
        [copyText]
    );

    const clonedIcon = useMemo(
        () =>
            isValidElement(trigger)
                ? cloneElement(trigger, {
                      //   @ts-ignore
                      'data-tooltip-id': uuid,
                      id: uuid,
                      onClick: handleOpen,
                  })
                : undefined,
        [trigger, uuid, handleOpen]
    );

    return (
        <div className='copy-container'>
            <Portal>
                <Tooltip
                    isOpen={isOpen}
                    id={uuid}
                    className={clsx('copy-pop-up', className)}
                >
                    {isOpen ? children : null}
                </Tooltip>
            </Portal>
            {clonedIcon ?? <CopyIcon data-tooltip-id={uuid} />}
        </div>
    );
};

export default CopyPopUp;
